var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAssetD(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "f0e73fa5-87c7-4deb-8f3a-a670cfb88e17@1.00x") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#2C2C30",
    fillRule: "nonzero",
    x: -2536,
    y: -2033,
    width: 7731,
    height: 6380
  }), /*#__PURE__*/React.createElement("g", {
    id: "icons/dark-UI/Asset_D",
    fill: "#FFFFFF",
    fillOpacity: 0.25
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.962,2 L4,6 L4,20 L14,22 L19.965,18 L19.965,15.999 L14,20 L14,17.92 L19.965,13.921 L19.965,12 L14,15.999 L14,13.921 L19.965,9.92 L19.965,7.999 L14,12 L14,9.92 L19.965,5.92 L19.965,4 L9.962,2 Z M6,12.692 L6,8.4 L12.001,9.595 L12.001,13.887 L6,12.692 Z",
    id: "Fill-1-Copy-2"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAssetD);
export default __webpack_public_path__ + "static/media/assetD.6261d8cf3f128c1cbd80c173808a0938.svg";
export { ForwardRef as ReactComponent };